export default {
  listaPaymentConfigs: [],
  paymentConfig: {
    id: null,
    registroId: null,
    formaPagamento: null,
    conta: null,
    tipoPagamento: null,
    principal: true,
  },
}
